import type { EmbedAttributes } from "./type";

export const DEFAULT_ATTRIBUTES: EmbedAttributes = {
  width: "100%",
  allowfullscreen: true,
  src: "",
  rawSrc: "",
  frameborder: false,
  aspectRatio: 16 / 9,
  maxWidth: null,
  minWidth: null,
  caption: null,
  align: "left",
};

export const EXTENSION_NAME = "embed";
